<template>
  <div class="menu-wrapper" @click="handleMenuItemClick">
    <template v-if="!item.children">
      <app-link v-if="item.meta.title" :to="resolvePath(item.path)">
        <el-menu-item
          :index="item.meta.id"
          :class="{ 'submenu-title-noDropdown': !isNest }"
          :style="{
            'padding-left': isCollapse ? 16 + 'px' : 16 + 12 * level + 'px',
          }"
        >
          <item
            is-last
            :icon="item.meta.icon"
            :title="$i18n.locale === 'EN' ? item.meta.titleEn : item.meta.title"
            :level="level"
            :is-collapse="isCollapse"
          />
        </el-menu-item>
      </app-link>
    </template>

    <el-submenu
      v-else
      ref="subMenu"
      :class="`customize-submenu-${level}`"
      :index="item.meta.id"
      :popper-class="`popper-submenu-${level}`"
      popper-append-to-body
    >
      <template slot="title">
        <item
          v-if="item.meta.title"
          :icon="item.meta.icon"
          :title="$i18n.locale === 'EN' ? item.meta.titleEn : item.meta.title"
          :level="level"
          :is-collapse="isCollapse"
        />
      </template>
      <sidebar-item
        v-for="child in item.children"
        :key="child.id"
        is-nest
        :item="child"
        :base-path="resolvePath(child.path)"
        :level="level + 1"
        :link-props="linkProps"
        class="nest-menu"
      />
    </el-submenu>
  </div>
</template>

<script>
import path from 'path'
import analytics from '../../../utils/analytics'
import Item from './Item'
import AppLink from './Link'
import FixIOSBug from './FixiOSBug'

export default {
  name: 'SidebarItem',
  components: { AppLink, Item }, // Item
  mixins: [FixIOSBug],
  props: {
    isCollapse: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      required: true
    },
    isNest: {
      type: Boolean,
      default: false
    },
    basePath: {
      type: String,
      default: ''
    },
    level: {
      type: Number,
      default: 0
    },
    linkProps: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {}
  },
  methods: {
    isExternal(path) {
      return /^(https?:|mailto:|tel:)/.test(path)
    },
    resolvePath(routePath) {
      if (this.isExternal(routePath)) {
        const urlParams = new URL(routePath)
        Object.entries(this.linkProps).forEach(([k, v]) => {
          if (urlParams.searchParams.has(k)) {
            urlParams.searchParams.set(k, v)
          } else {
            urlParams.searchParams.append(k, v)
          }
        })
        const url = urlParams.toString()
        return url
      }
      return path.resolve(this.basePath, routePath)
    },
    handleMenuItemClick(){
      if(!this.item.children) {
        const currentRoutePath = this.$route.path
        const path = this.resolvePath(this.item.path)
        const isClickActiveMenu = currentRoutePath === this.item.path // 处于激活的菜单再次点击不需要上报
        if(isClickActiveMenu) {
          return
        }
        const title = this.$i18n.locale === 'EN' ? this.item.meta.titleEn : this.item.meta.title
        const analyticsInstance = analytics.getAnalyticsInstance(this)
        analyticsInstance.reportEvent('sidebar_item_click', {
          sidebar_item_title: title,
          sidebar_item_target_url_path: path
        })
      }
    }
  }
}
</script>
